import { Button, message, Upload } from "antd";
import styles from "./styles.module.css";
import {
  UploadOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

export const UploadReceiptForm = ({ formData, setFormData }: any) => {
  const uploadProps = {
    name: "receipt",
    accept: "image/*,.pdf",
    maxCount: 1,
    beforeUpload: (file: any) => {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error("File must be smaller than 5MB!");
        return false;
      }
      setFormData((prev: any) => ({ ...prev, evidence: file }));
      return false;
    },
    onRemove: () => {
      setFormData((prev: any) => ({ ...prev, evidence: null }));
    },
  };

  return (
    <>
      <div className={styles.uploadSection}>
        <h3 className={styles.uploadTitle}>
          <FileTextOutlined /> Upload Payment Receipt
        </h3>
        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />} block size="large">
            Select Receipt File
          </Button>
        </Upload>
        <p className={styles.uploadHint}>
          Accepted formats: JPG, PNG, PDF (Max size: 5MB)
        </p>
        {formData.receipt && (
          <div
            style={{
              marginTop: "16px",
              padding: "12px",
              backgroundColor: "#d1fae5",
              borderRadius: "8px",
            }}
          >
            <CheckCircleOutlined
              style={{ color: "#10b981", marginRight: "8px" }}
            />
            <span style={{ color: "#065f46", fontWeight: "500" }}>
              Receipt uploaded successfully: {formData.evidence.name}
            </span>
          </div>
        )}
      </div>
    </>
  );
};
